var __rspack_ns_object = {"rE":"3.49.3"}